var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _circle, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5137 27.1284L43.31 8.83789L31.4219 22.9198V55.6615H52.5137V27.1284Z",
    fill: "#5E676F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.486328 26.3965H32.8271V55.6613H0.486328V26.3965Z",
    fill: "#98A1A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7344,
    y: 35.1768,
    width: 8.43672,
    height: 8.77943,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8574,
    y: 38.1025,
    width: 7.0306,
    height: 17.5589,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1749 8.83789H11.5077L0.486328 26.3968H32.8271L43.1749 8.83789Z",
    fill: "#1F2E3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4336,
    y: 15.8682,
    width: 26.5811,
    height: 22.2358,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0781,
    y: 24.2285,
    width: 3.2905,
    height: 9.31054,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7242,
    cy: 24.2281,
    r: 3.79454,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 18.7284V11.1861C20.875 6.85166 24.3888 3.33789 28.7232 3.33789V3.33789C33.0577 3.33789 36.5714 6.85165 36.5714 11.1861V18.7284",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllStep3);
export default __webpack_public_path__ + "static/media/IcEstateAllStep3.4a2a0cb8d2b62b46351081ffd857df99.svg";
export { ForwardRef as ReactComponent };